<template>
  <div class="referral-status-container">
    <h3 v-translate class="heading-3">Referral Status</h3>

    <div v-if="referralsLoadingState || tokensLoadingState" class="loader"></div>
    <referral-status-panel-not-found v-else-if="noReferralEvents" :refereeName="refereeName"></referral-status-panel-not-found>
    <div v-else>
      <referral-application
        v-for="(events,key) in applicationEvents"
        :key="key"
        :index="getApplicationIndex(key)"
        :referred-job="getReferredJob(key)"
        :events="events"
        :refereeName="refereeName">
      </referral-application>
    </div>
  </div>
</template>

<script>

import {isEmpty} from 'lodash';
import CardPanel from 'top20common/components/card-panel/CardPanel';
import TimelineList from 'top20common/components/timeline/TimelineList';
import {mapGetters} from 'vuex';

import tokensHelper from '@/utils/tokens-helper';

import ReferralStatusPanelNotFound from './ReferralStatusPanelNotFound.vue';
import ReferralApplication from './application/ReferralApplication';

export default {
  data() {
    return {
      grantedTokens: {applied: false, interview: false, hired: false},
      omitStage: 'dismissed'
    };
  },
  computed: {
    ...mapGetters([
      'referralsLoadingState',
      'referralDetailsBySlugState',
      'isTokenGrantedByReferral',
      'tokensLoadingState'
    ]),
    referralSlug() {
      return this.$route.params.slug;
    },
    referralDetails() {
      let referralDetails = this.referralDetailsBySlugState[this.referralSlug];
      return referralDetails || {};
    },
    refereeName() {
      return this.referralDetails.first_name || '';
    },
    noReferralEvents() {
      return isEmpty(this.applicationEvents);
    },
    applicationEvents() {
      let eventsByApplication = {};
      if (this.referralDetails.events) {
        this.referralDetails.events.forEach(item => {
          let applicationId = item.application_id;

          if (applicationId) {
            eventsByApplication[applicationId] = eventsByApplication[applicationId] || [];
            eventsByApplication[applicationId].push(this.setGrantedToken(item));
          }
        });
      }
      this.resetGrantedTokens();
      return eventsByApplication;
    }
  },
  methods: {
    isTokenGranted(status) {
      let tokenType = tokensHelper.getTokenTypeByStatus(status);
      return this.grantedTokens[status] === false && this.isTokenGrantedByReferral(this.referralDetails.id, tokenType);
    },
    resetGrantedTokens() {
      Object.keys(this.grantedTokens).map(key => {
        this.grantedTokens[key] = false;
      });
    },
    setGrantedToken(event) {
      let _event = {...event};
      let status = _event.application_status;
      if (this.isTokenGranted(status)) {
        _event.token = {type: tokensHelper.getTokenTypeByStatus(status)};
        this.grantedTokens[status] = true;
      }
      return _event;
    },
    getApplicationIndex(key) {
      return Object.keys(this.applicationEvents).indexOf(key) + 1;
    },
    getReferredJob(appId) {
      let applicationIdOfReferredJob = this.referralDetails.referred_job.application_id;

      if (applicationIdOfReferredJob && applicationIdOfReferredJob === appId) {
        return this.referralDetails.referred_job;
      }
    }
  },
  components: {
    CardPanel,
    ReferralStatusPanelNotFound,
    ReferralApplication,
    TimelineList
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.referral-status-container {
  margin-bottom: 30px;

  .heading-3 {
    padding-bottom: 30px;
  }

  /deep/ .card-panel .header-card-panel {
    height: auto;
  }

  .timeline-list {
    /deep/ .timeline-item {
      padding-bottom: 12px;
    }
  }
}

@media (max-width: $tablet) {
  .referral-status-container {
    margin-bottom: 20px;

    .heading-3 {
      padding-bottom: 15px;
    }
  }
}
</style>
